import gql from "graphql-tag";

export default gql`
  query userAdministrationAccounts($shopIds: [ID], $filters: AccountFilterInput, $first: ConnectionLimitInt, $offset: Int) {
    userAdministrationAccounts(shopIds: $shopIds, filters: $filters, first: $first, offset: $offset) {
      nodes {
        _id
        userId
        name
        firstName
        lastName
        company
        primaryEmailAddress
        confirmedEmail
        isActivated
        isFamilyAndFriends
        invoicePaymentAllowed
        backendAccess
        specialRouteAccess
        createdAt
        updatedAt
        vatId
        datevId
        language
        note
        emailRecords {
          address
          provides
          verified
        }
        invoiceAddress {
          fullName
          firstName
          lastName
          address1
          address2
          street
          houseNumber
          city
          country
          phone
          postal
          region
        }
        addressBook {
          nodes {
            _id
            fullName
            address1
            address2
            city
            country
            phone
            postal
            region
          }
        }
        groups(first: 100) {
          nodes {
            _id
            name
            slug
            permissions
          }
        }
      }
      totalCount
    }
  }
`;
